import { findAllPositions } from '@src/main/modules/parameters/application/find/find-all-positions.usecase';
import { PositionRepository } from '@src/main/modules/parameters/domain/fleet-positions/position.repository';
import { createPositionHttpRepository } from '@src/main/modules/parameters/infrastructure/repository/PositionHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useQuery } from '@tanstack/react-query';
import { useCallback, useEffect, useMemo, useState } from 'react';

export const usePositions = () => {
  const { user } = useAuth();
  const [repository, setRepository] = useState<PositionRepository | null>(null);

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  useEffect(() => {
    if (user?.token) {
      const repo = createPositionHttpRepository(tokenProvider);
      setRepository(repo);
    } else {
      setRepository(null);
    }
  }, [user?.token, tokenProvider]);

  const queryResult = useQuery({
    queryKey: ['position'],
    queryFn: async () => {
      if (!repository) throw new Error('Repository not available');
      return await findAllPositions(repository);
    },
    enabled: !!repository,
    staleTime: 1000 * 60,
  });

  return { ...queryResult, repository };
};
